<template>
  <div class="copilotKitInputContainer">
    <div class="copilotKitInput" @click="focusTextarea">
      <textarea
        ref="textarea"
        v-model="text"
        :placeholder="placeholder"
        :disabled="disabled"
        rows="1"
        @keydown="onKeydown"
        @input="autoResize"
        @compositionstart="composing = true"
        @compositionend="composing = false"
      ></textarea>
      <div class="copilotKitInputControls">
        <button
          v-if="isRunning"
          class="copilotKitInputControlButton"
          @click.stop="$emit('stop')"
          title="Stop"
          v-html="StopIcon"
        ></button>
        <button
          v-else
          class="copilotKitInputControlButton"
          :disabled="!canSend"
          @click.stop="send"
          title="Send"
          v-html="SendIcon"
        ></button>
      </div>
    </div>
  </div>
</template>

<script>
import { SendIcon, StopIcon } from './agentIcons';

export default {
  name: 'AgentInput',
  props: {
    isRunning: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    placeholder: { type: String, default: 'Type a message...' },
  },
  data() {
    return {
      text: '',
      composing: false,
      SendIcon,
      StopIcon,
    };
  },
  computed: {
    canSend() {
      return this.text.trim().length > 0 && !this.disabled && !this.isRunning;
    },
  },
  methods: {
    focusTextarea() {
      this.$refs.textarea.focus();
    },
    onKeydown(e) {
      if (e.key === 'Enter' && !e.shiftKey && !this.composing) {
        e.preventDefault();
        if (this.canSend) this.send();
      }
    },
    send() {
      const msg = this.text.trim();
      if (!msg) return;
      this.$emit('send', msg);
      this.text = '';
      this.$nextTick(() => this.autoResize());
    },
    autoResize() {
      const ta = this.$refs.textarea;
      if (!ta) return;
      ta.style.height = 'auto';
      const lineHeight = 24;
      const maxHeight = lineHeight * 6;
      ta.style.height = Math.min(ta.scrollHeight, maxHeight) + 'px';
      ta.style.overflowY = ta.scrollHeight > maxHeight ? 'auto' : 'hidden';
    },
  },
};
</script>
